import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { EgresadoDisclaimer } from "@/components/EgresadoDisclaimer";

// Official multicolor "G" (Google brand guidelines).
const GoogleG = () => (
  <svg viewBox="0 0 48 48" width="20" height="20" aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
  </svg>
);

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const GoogleButton = ({ label = "Iniciar sesión con Google", claimToken, visible, aceptaTerminos, testid = "google-login-btn", disclaimer = false }) => {
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/auth/google/config").then((r) => setEnabled(r.data.enabled)).catch(() => setEnabled(false));
  }, []);

  if (!enabled) return null;

  const go = async () => {
    if (claimToken && !aceptaTerminos) {
      toast.error("Tenés que aceptar los Términos y Condiciones de uso para activar tu cuenta");
      return;
    }
    setBusy(true);
    try {
      const r = await api.post("/auth/google/start", {
        redirect_uri: window.location.origin + "/auth/google",
        claim_token: claimToken || null,
        visible_para_empresas: !!visible,
        acepta_terminos: !!aceptaTerminos,
      });
      window.location.href = r.data.url;
    } catch (e) {
      toast.error(e.response?.data?.detail || "No se pudo iniciar el ingreso con Google");
      setBusy(false);
    }
  };

  return (
    <>
      <div className="my-4 flex items-center gap-3 text-xs text-[var(--brand-text-muted)]"><span className="flex-1 h-px bg-slate-200" />o<span className="flex-1 h-px bg-slate-200" /></div>
      {disclaimer && <EgresadoDisclaimer testid="google-egresado-disclaimer" className="mb-3" />}
      <button type="button" onClick={go} disabled={busy} data-testid={testid} aria-label={label}
        className="w-full h-10 inline-flex items-center justify-center gap-3 rounded-full border border-[#747775] bg-white px-3 text-[#1F1F1F] text-sm font-medium transition-colors hover:bg-[#F8F9FA] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#4285F4] disabled:opacity-60"
        style={{ fontFamily: "'Roboto', arial, sans-serif", letterSpacing: "0.25px" }}>
        <GoogleG />
        <span>{busy ? "Redirigiendo…" : label}</span>
      </button>
    </>
  );
};
